@let _reinsurancesPdp = reinsurancesPdp();

@if (_reinsurancesPdp?.length > 0) {
  <sd-accordion-group layout="light">
  @for (reinsurancePdp of _reinsurancesPdp; track reinsurancePdp.title) {
     @let description = reinsurancePdp.description;
     @let title = reinsurancePdp.title;

      <sd-accordion
         (toggled)="onReinsurancesPdpClick(reinsurancePdp.type)"
         [iconNameClosed]="!description ? undefined : 'icon-plus'"
         iconNameOpened="icon-minus"
         [title]="title"
         [titleIcon]="reinsurancePdp.icon"
         [titleInfo]="reinsurancePdp.info"
         [iconPos]="PositionEnum.right"
         [iconSize]="IconSizeEnum.xs"
         [isDisabled]="!description"
         titleCustomClass="font-default"
         [isDescription]="true"
         [theme]="ThemesEnum.dark">
        @if (description){
          <sd-html tag="span" [html]="description"/>
        }
      </sd-accordion>
  }
  </sd-accordion-group>
}
